import { hasGon } from '@common/lib/gon';
import type { Gon } from '@console/common/window';

const G4B_MYPAGE_PATHES = {
  DASHBOARD: {
    PROJECTS: 'dashboard/projects'
  }
};

const getG4bMyPageEndpoint = (): string => {
  if (hasGon<Gon>(window)) {
    const { g4bMyPageEndpoint } = window.gon;
    return g4bMyPageEndpoint || '';
  } else {
    return '';
  }
};

export const getG4bMyPageContentsUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/contents`;
};

export const getG4bMyPageProjectsUrl = (): string =>
  `${getG4bMyPageEndpoint()}/${G4B_MYPAGE_PATHES.DASHBOARD.PROJECTS}`;

export const getG4bMyPageImmediateDeliveryUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard/projects/new/immediate_delivery_entry/agreement`;
};

export const getG4bMyPageBulkEntryUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard/projects/new/bulk_entry/cart`;
};

export const getG4bMyPageApiEntryUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard/projects/new/api/cart`;
};

export const getG4bMyPageGifteePlusSolutionEntryUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard/projects/new/giftee_plus_solution`;
};

export const getG4bMyPageAccountLoginUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/account/login`;
};
export const getG4bMyPagePasswordResetUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/account/password_reset_requests`;
};

export const getG4bMyPageAccountDistributionPartnerUrl = (
  distributionPartnerUrlCode: string
): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard/account/distribution_partner/${distributionPartnerUrlCode}`;
};

export const getG4bMyPageDashboardUrl = (): string => {
  const g4bMyPageEndpoint = getG4bMyPageEndpoint();
  return `${g4bMyPageEndpoint}/dashboard`;
};
